<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Download">
  <!-- pdf -->
  <div class="card border-0 shadow margin-item">
    <div class="w-100 worksheet-image-height position-relative rounded">
      <img
        class="w-100 worksheet-image-height object-cover rounded-img"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <div class="fw-bold text-black p-2 font-size-20 position-relative mb-3 center-absolute w-100">
      {{ worksheetItem.Description }}
    </div>
    <div
      target="_blank"
      (click)="getDownload(worksheetId, worksheetItem.Id)"
      class="btn btn-primary bg-button text-white border-0 mt-5 p-2 m-2 fw-bold font-size-14"
    >
      {{ 'worksheet.download' | translate | uppercase }}
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Gallery">
  <!-- image -->
  <div class="border-0 my-3 rounded">
    <div (click)="openGalleryImage(galleryImage)">
      <img
        class="w-100 worksheet-image-height object-cover rounded"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
  </div>

  <ng-template #galleryImage let-modal>
    <div class="modal-header border-0 justify-content-center pb-1">
      <button type="button" class="btn close" (click)="modal.dismiss()">
        <span class="icon material-icons text-white">cancel</span>
      </button>
    </div>
    <div class="modal-body d-flex justify-content-center pt-0">
      <img
        *ngIf="worksheetItem.Image"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        class="modal-image"
        [alt]="worksheetItem.Title"
        [@zoomAnimation]
      />
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.ProviderVideo">
  <!-- video -->
  <div class="border-0 my-3 rounded">
    <div [ngSwitch]="worksheetItem.ProviderId">
      <ng-container *ngSwitchCase="providerName.Facebook">
        <fgb-facebook-player [streamKey]="worksheetItem.ProviderKey"></fgb-facebook-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.YouTube">
        <fgb-youtube-player [streamKey]="worksheetItem.ProviderKey"></fgb-youtube-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamingVideoProvider">
        <fgb-svp-player [streamKey]="worksheetItem.ProviderKey"></fgb-svp-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Twitch">
        <fgb-twitch-player [streamKey]="worksheetItem.ProviderKey"></fgb-twitch-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Viemo">
        <fgb-vimeo-player [streamKey]="worksheetItem.ProviderKey"></fgb-vimeo-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Boxcast">
        <fgb-boxcast-player [streamKey]="worksheetItem.ProviderKey"></fgb-boxcast-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Streamable">
        <fgb-streamable-player [streamKey]="worksheetItem.ProviderKey"></fgb-streamable-player>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Link">
  <!-- link -->
  <div class="card border-0 shadow my-3 rounded">
    <div>
      <img
        class="w-100 worksheet-image-height object-cover rounded-img"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />

      <div class="mt-2 mb-4 p-2 fw-bold">{{ worksheetItem.Description }}</div>

      <a
        target="_blank"
        [href]="worksheetItem.LinkUrl"
        class="btn btn-primary bg-primary text-white border-0 p-2 m-2 fw-bold font-size-14"
        >{{ 'worksheet.download' | translate | uppercase }}</a
      >
    </div>
  </div>
</ng-container>
